import React, { useState, useEffect, useRef } from 'react';
import './Styles.css';

function Contact() {
  const [openModal, setOpenModal] = useState(null);
  const modalRef = useRef(null);

  const handleCardClick = (cardId) => {
    setOpenModal(cardId);
  };

  const closeModal = () => {
    setOpenModal(null);
  };

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      closeModal();
      event.stopPropagation();
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        closeModal();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const cardData = [
    {
      id: 'card1',
      title: 'Registered Address',
      content: 'Aura Voyages Private Limited <br /> Block C-131, 7th floor, National Apartment, Dwarka Sector 3, New Delhi - 110059, India <br /> e: info@auravoyages.com <br /> <br /> CIN: U63000DL2014PTC266207',
    },
    {
      id: 'card2',
      title: 'Office Location',
      content: 'Aura Voyages Private Limited <br /> Sunview Apartment, Flat 384, Sector 11, Pocket 4, Dwarka, New Delhi – 110078, India',
    },
    {
      id: 'card3',
      title: 'China Office',
      content: 'Ms Heidi <br /><br /> T: 0086-13910387047 <br />  heidi@beocean.cn | heidi@easychinatours.com <br /> Office Address: No.029 First floor, Building C, No. 65 Nan Sanhuan Xilu, Fengtai District, Beijing, China',
    },
    {
      id: 'card4',
      title: 'Spain Office',
      content: 'Guillermo Gil <br /><br /> T: (+34) 646 178 684 <br />  ggil@smarttravelplanet.com <br />',
    },
    {
      id: 'card5',
      title: 'France Office',
      content: 'Représentant en France - Aura voyages <br /> Philippe <br /><br /> T: +33.6.15.39.31.88 <br /> philippe@auravoyages.com <br /> Office Address: Région de Lyon',
    },
    {
      id: 'card6',
      title: 'Aura Voyages + Abled Traveller',
      content: 'Ravinder Singh ATRI <br />  +91 98107 20202 (m/whatsapp) <br /> e: info@auravoyages.com <br /><a href=\'https://www.linkedin.com/in/ravinder-singh-atri-teacher-of-yoga-accessible-travel-designer-3a133424/\'>linkedin - Ravinder Atri</a>',
    },
    {
      id: 'card7',
      title: 'Aura Voyages + Abled Traveller',
      content: 'Arun Sharma <br /> +91 98106 81018 (m/whatsapp)  <br /> e: info@abledtraveller.com <br /><a href=\'https://www.linkedin.com/in/arun-sharma-172154ba/\'>linkedin - Arun Sharma</a>',
    },
    {
      id: 'card8',
      title: 'Himalayan Voyages',
      content: 'Virender Singh ATRI <br /> +91 95993 34588 (m/whatsapp) <br /> e: info@himalayanvoyages.com <br /><a href=\'https://www.linkedin.com/in/virender-singh-99715359/\'>linkedin - Virender Atri</a>',
    },
  ];

  return (
    <React.Fragment>
      <div className='ContactBg'>
        <div className='ContactPgCont'>
          <div className="HeadContactPg ">
            <p> Contact Us </p> <br />
          </div>
            <div className='CardDisp'>
            {cardData.map((card) => (
              <div key={card.id} className="AddressCard" onClick={() => handleCardClick(card.id)}>
                <div dangerouslySetInnerHTML={{ __html: card.title + (card.content ? '<br /><br />' : '') + card.content }} />
                {openModal === card.id && (
                  <div className="modal-overlay">
                    <div className="modal-content" ref={modalRef}>

                      <div className="modal-close" onClick={closeModal}>
                        &#x2715;
                      </div>
                      <div className='modal-text' dangerouslySetInnerHTML={{ __html: card.title + '<br /><br />' + card.content }} />
                    </div>
                  </div>
                )}              
              </div>
              
            ))}
          </div>
          
          </div>
      </div>
      
      </React.Fragment>
      
  );
}

export default Contact;
